import { render, staticRenderFns } from "./BenefitsMtBy.vue?vue&type=template&id=2753b943"
import script from "./BenefitsMtBy.vue?vue&type=script&lang=js"
export * from "./BenefitsMtBy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports